/**
 * District Filter Component
 *
 * Reusable district selector for filtering data by district
 */

import { MapPin } from 'lucide-react'

export interface District {
  id: number
  name_th: string
  name_en: string
  code: string
  population?: number
}

interface DistrictFilterProps {
  selectedDistrict: number | null
  onDistrictChange: (districtId: number | null) => void
  districts: District[]
  label?: string
  showAll?: boolean
  className?: string
  isLoading?: boolean
}

export function DistrictFilter({
  selectedDistrict,
  onDistrictChange,
  districts,
  label = 'อำเภอ',
  showAll = true,
  className = '',
  isLoading = false,
}: DistrictFilterProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <MapPin className="w-4 h-4 text-slate-500" />
      <label className="text-sm font-medium text-slate-700">{label}:</label>
      <select
        value={selectedDistrict ?? ''}
        onChange={(e) => onDistrictChange(e.target.value ? Number(e.target.value) : null)}
        disabled={isLoading}
        className="px-3 py-1.5 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-korat-orange-500 focus:border-korat-orange-500 bg-white text-sm font-medium text-slate-700 hover:border-slate-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed min-w-[200px]"
      >
        {showAll && <option value="">ทุกอำเภอ</option>}
        {districts.map((district) => (
          <option key={district.id} value={district.id}>
            {district.name_th}
            {district.population && ` (ประชากร: ${district.population.toLocaleString('th-TH')})`}
          </option>
        ))}
      </select>
    </div>
  )
}
